const decodeOptionalRequirementValue = (value) => value && value > 0 ? value : undefined;
export const decodeFinancial = (financial) => {
    return {
        estimatedACTHours: decodeOptionalRequirementValue(financial.estimated_act_hours),
        estimatedBepHoursManagement: decodeOptionalRequirementValue(financial.estimated_bep_hours_management),
        estimatedBepHoursNonTrade: decodeOptionalRequirementValue(financial.estimated_bep_hours_non_trade),
        estimatedBepHoursTrade: decodeOptionalRequirementValue(financial.estimated_bep_hours_trade),
        estimatedTotalWorkHours: decodeOptionalRequirementValue(financial.estimated_total_work_hours),
        id: financial.financial_id,
        totalValue: financial.total_value
    };
};
export const encodeFinancial = (financial) => {
    return {
        estimated_act_hours: financial.estimatedACTHours ?? 0,
        estimated_bep_hours_management: financial.estimatedBepHoursManagement ?? 0,
        estimated_bep_hours_non_trade: financial.estimatedBepHoursNonTrade ?? 0,
        estimated_bep_hours_trade: financial.estimatedBepHoursTrade ?? 0,
        estimated_total_work_hours: financial.estimatedTotalWorkHours ?? 0,
        financial_id: financial.id,
        total_value: financial.totalValue ?? 0
    };
};
